import { CalendlyExpert } from '@/features/experts/types/CalendlyExpert';
import { VenereBox, VenereButton } from "../../shared/ui";
import { VenereExpertBookingCalendar } from './VenereExpertBookingCalendar';

interface VenereConsultBoxProps {
  id: string
  imageSrc: string
  imageAlt: string
  role: string
  name: string
  expert?: CalendlyExpert
  onBookClick?: () => void
  imageClassName?: string
  isExpanded?: boolean
  onExpand?: (cardId: string) => void
}

const VenereConsultBox: React.FC<VenereConsultBoxProps> = ({
  id,
  imageSrc,
  imageAlt,
  role,
  name,
  expert,
  onBookClick,
  imageClassName = "w-16 h-16 object-contain rounded-[20px]",
  isExpanded = false,
  onExpand
}) => {
  const handleBookClick = () => {
    if (expert && onExpand) {
      onExpand(id);
    } else {
      onBookClick?.();
    }
  };

  const handleExpertBookClick = (expert: CalendlyExpert) => {
    if (onExpand) {
      onExpand(id); // Close the card after booking
    }
    // You could add additional logic here like analytics tracking
    console.log('Booking completed for expert:', expert.data.name);
    
    // Optionally trigger a refetch of appointments here if needed
    // This would be useful if you want to update the appointments list immediately
  };

  return (
    <div className={`transition-all duration-300 ease-in-out ${
      isExpanded && expert 
        ? 'md:col-span-2 md:row-span-2' 
        : ''
    }`}>
      <VenereBox variant="seasalt" className="w-full h-full">
        <div className="w-full rounded-lg p-4 flex flex-col items-center gap-2">
          <img 
            src={imageSrc} 
            alt={imageAlt}
            className={imageClassName}
          />
          <div className="venere-text-secondary">{role}</div>
          <div className="venere-text-primary">{name}</div>
          <VenereButton onClick={handleBookClick}>
            {expert && isExpanded ? 'Chiudi calendario' : 'Prenota'}
          </VenereButton>
        </div>
        
        {/* Booking Calendar */}
        {expert && isExpanded && (
          <VenereExpertBookingCalendar
            expert={expert}
            onBookClick={handleExpertBookClick}
          />
        )}
      </VenereBox>
    </div>
  )
}

export default VenereConsultBox 